import React from 'react';

import { Box } from '@vk-hr-tek/ui/Box';

import { ContentSurveysFormValues } from '../../types';

import { PassedSurveyNotification } from './PassedSurveyNotification';
import { CommonSection, SettingsSection, QuestionsSection } from './sections';

interface ContentSurveysFormProps {
  editContentSurvey: ContentSurveysFormValues | null;
}

export const ContentSurveysFormContent = ({
  editContentSurvey,
}: ContentSurveysFormProps) => {
  return (
    <Box display="flex" flexDirection="column" gap="24">
      {editContentSurvey?.meta?.isPassed && <PassedSurveyNotification />}

      <CommonSection />
      <QuestionsSection isEdit={Boolean(editContentSurvey)} />
      <SettingsSection />
    </Box>
  );
};
